import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shortcutGroupTitle: {
    id: 'frontbucket.keyboardShortcuts.global.shortcutGroupTitle',
    description: 'Title for the group of global keyboard shortcuts',
    defaultMessage: 'Global actions',
  },
  toggleKeyboardShortcutMenuShortcut: {
    id: 'frontbucket.keyboardShortcuts.global.toggleKeyboardShortcutMenuShortcut',
    description:
      'Description of a keyboard shortcut to open the keyboard shortcut help menu',
    defaultMessage: 'Display keyboard shortcuts',
  },
  toggleNavigationShortcut: {
    id: 'frontbucket.keyboardShortcuts.global.toggleNavigationShortcut',
    description: 'Description of a keyboard shortcut to open the navigation',
    defaultMessage: 'Expand and collapse navigation',
  },
  toggleSearchShortcut: {
    id: 'frontbucket.keyboardShortcuts.global.toggleSearchShortcut',
    description: 'Description of a keyboard shortcut to open the global search',
    defaultMessage: 'Focus the site search',
  },
});
